import Checkbox from "components/formElements/Checkbox/Checkbox";
import "./style.css";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line no-shadow
export enum PasswordStatus {
  Lowercase,
  Uppercase,
  NumberOrSymbol,
  MinimumLength,
}

type Props = {
  passwordStatus: PasswordStatus[];
};

function PasswordRequirement(props: Props) {
  const { t } = useTranslation();
  return (
    <div className="password-requirement-component">
      <div>{t("Common.Password requirements")}:</div>
      <div className="password-confirm-list">
        <Checkbox
          isChecked={props.passwordStatus.includes(PasswordStatus.Lowercase)}
          label={t("Common.lower case letter")}
        />
        <Checkbox
          isChecked={props.passwordStatus.includes(PasswordStatus.Uppercase)}
          label={t("Common.upper case letter")}
        />
        <Checkbox
          isChecked={props.passwordStatus.includes(PasswordStatus.NumberOrSymbol)}
          label={t("Common.number or symbol")}
        />
        <Checkbox
          isChecked={props.passwordStatus.includes(PasswordStatus.MinimumLength)}
          label={t("Common.at least 8 characters")}
        />
      </div>
    </div>
  );
}

export default PasswordRequirement;
